function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { useCallback, useEffect, useState } from "react";
import { useAsyncFn } from "react-use";
import { get } from "lodash";
import usePaginationProps from "../components/DataGrid/usePaginationProps";
import { formatAnyValue } from "../facade/format/formatAnyValue";
import exportDataToExcel from "../utils/exportDataToExcel";
var useFetchList = function(columns, fetcher) {
    var _value_page;
    var paginationProps = usePaginationProps(0);
    var _useState = _sliced_to_array(useState({}), 2), filterFormValues = _useState[0], setFilterFormValues = _useState[1];
    var _useAsyncFn = _sliced_to_array(useAsyncFn(function() {
        var _ref = _async_to_generator(function(filter) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetcher({
                                filter: filter,
                                pageable: {
                                    page: paginationProps.page,
                                    size: paginationProps.rowsPerPage
                                }
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(filter) {
            return _ref.apply(this, arguments);
        };
    }(), [
        fetcher,
        paginationProps.page,
        paginationProps.rowsPerPage
    ]), 2), _useAsyncFn_ = _useAsyncFn[0], loading = _useAsyncFn_.loading, value = _useAsyncFn_.value, error = _useAsyncFn_.error, doFetch = _useAsyncFn[1];
    var handleSubmitFilter = function(filter) {
        setFilterFormValues(filter);
        paginationProps.onChangePage(0);
    };
    var downloadExcel = useCallback(/*#__PURE__*/ _async_to_generator(function() {
        var size, results, page, _response_results, response, _response_results1, excelRows;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    size = 1000;
                    results = [];
                    page = 0;
                    _state.label = 1;
                case 1:
                    if (!true) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetcher({
                            filter: filterFormValues,
                            pageable: {
                                page: page++,
                                size: size
                            }
                        })
                    ];
                case 2:
                    response = _state.sent();
                    results = results.concat((_response_results1 = response.results) !== null && _response_results1 !== void 0 ? _response_results1 : []);
                    if (!((_response_results = response.results) === null || _response_results === void 0 ? void 0 : _response_results.length)) return [
                        3,
                        3
                    ];
                    return [
                        3,
                        1
                    ];
                case 3:
                    excelRows = results.map(function(result) {
                        return columns.reduce(function(row, _param) {
                            var header = _param.header, id = _param.id, column = _object_without_properties(_param, [
                                "header",
                                "id"
                            ]);
                            var _column_formatValue;
                            var value = get(result, id);
                            var _column_formatValue1;
                            return _object_spread_props(_object_spread({}, row), _define_property({}, header !== null && header !== void 0 ? header : id, (_column_formatValue1 = (_column_formatValue = column.formatValue) === null || _column_formatValue === void 0 ? void 0 : _column_formatValue.call(column, value, result)) !== null && _column_formatValue1 !== void 0 ? _column_formatValue1 : formatAnyValue(value)));
                        }, {});
                    });
                    exportDataToExcel(excelRows);
                    return [
                        2
                    ];
            }
        });
    }), [
        columns,
        fetcher,
        filterFormValues
    ]);
    useEffect(function() {
        doFetch(filterFormValues);
    }, [
        doFetch,
        filterFormValues
    ]);
    useEffect(function() {
        var _value_page;
        if ((value === null || value === void 0 ? void 0 : (_value_page = value.page) === null || _value_page === void 0 ? void 0 : _value_page.totalCount) != null) {
            paginationProps.setCount(value.page.totalCount);
        }
    }, [
        paginationProps,
        value === null || value === void 0 ? void 0 : (_value_page = value.page) === null || _value_page === void 0 ? void 0 : _value_page.totalCount
    ]);
    var _value_results;
    return {
        columns: columns,
        filter: filterFormValues,
        setFilter: handleSubmitFilter,
        rows: (_value_results = value === null || value === void 0 ? void 0 : value.results) !== null && _value_results !== void 0 ? _value_results : [],
        pagination: paginationProps,
        loading: loading,
        error: error,
        downloadExcel: downloadExcel
    };
};
export default useFetchList;
